"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const browser_rest_client_1 = require("@upside/browser-rest-client");
const axios_1 = __importDefault(require("axios"));
const event_bus_1 = require("../event-bus");
class EnvironmentAuthenticationContext {
    constructor(eventBus, apiKey, source = EnvironmentAuthenticationContext.DEFAULT_TOKEN_SOURCE) {
        this.eventBus = eventBus;
        this.apiKey = apiKey;
        this.source = source;
        this.isLoggedIn = source() !== undefined;
        if (this.isLoggedIn) {
            this.eventBus.emit(event_bus_1.StandardEvents.Login);
        }
    }
    static create(parameters, source) {
        return new EnvironmentAuthenticationContext(parameters.eventBus, parameters.apiKey, source);
    }
    token() {
        return Promise.resolve(this.source());
    }
    locale() {
        return Promise.resolve('en-GB');
    }
    get client() {
        if (!this.isLoggedIn) {
            throw new Error('Cannot create authenticated client when not logged in');
        }
        const instance = axios_1.default.create({});
        return (0, browser_rest_client_1.addAuthenticationToAxiosClient)(instance, async () => this.source(), this.apiKey);
    }
    get loggedIn() {
        return this.isLoggedIn;
    }
    async login() {
        this.logout();
        this.isLoggedIn = this.source() !== undefined;
        if (this.isLoggedIn) {
            this.eventBus.emit(event_bus_1.StandardEvents.Login);
        }
        return this.isLoggedIn;
    }
    async changePassword(currentPassword, newPassword) {
        if (currentPassword !== newPassword) {
            this.eventBus.emit(event_bus_1.StandardEvents.ChangePassword);
            return {
                success: true,
            };
        }
        return {
            success: false,
        };
    }
    logout() {
        if (this.isLoggedIn) {
            this.isLoggedIn = false;
            this.eventBus.emit(event_bus_1.StandardEvents.Logout);
        }
    }
}
EnvironmentAuthenticationContext.ACCESS_TOKEN_KEY = 'UPSIDE_ACCESS_TOKEN';
EnvironmentAuthenticationContext.DEFAULT_TOKEN_SOURCE = () => process.env[EnvironmentAuthenticationContext.ACCESS_TOKEN_KEY];
exports.default = EnvironmentAuthenticationContext;
//# sourceMappingURL=data:application/json;base64,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